import NonInteractiveLinedInput from "./NonInteractiveLinedInput";
export default NonInteractiveLinedInput;
